import React, { Fragment, useEffect, useState } from 'react';
import { LoadingComponent } from 'recupero-comunes';
import { Form } from 'react-bootstrap';
import AdministracionCaso from './AdministracionCaso';
import { useFormik } from 'formik';
import { useDispatch } from 'react-redux';
import { configuracionFormAction43, obtenerListaImplicados, obtenerDatosGestionImplicadoDefault, obtenerTareasPendientes } from '../../store/actions/administracion-caso-action'
import { useSelector } from 'react-redux';
import { Auth } from 'recupero-comunes';

const Administracion = ({origen}) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);

    const data_encargado = useSelector((state) => state.encargadoCompaniaReducer);
    const { llaves } = data_encargado;

    useEffect(() => {
        if (llaves) {
            setLoading(true);
            let query = Buffer.from(JSON.stringify({ rutcia: llaves['idOrgCaso'], idform: 43 })).toString('base64');

            dispatch(configuracionFormAction43(query))
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ idOrgCaso: llaves['idOrgCaso'], idCaso: llaves['idCaso'] })).toString('base64');
                    dispatch(obtenerListaImplicados(query));
                })
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idImplicado": 0 })).toString('base64');
                    dispatch(obtenerDatosGestionImplicadoDefault(query))
                })
                .then(() => {
                    let query = Buffer.from(JSON.stringify({ "idCaso": llaves["idCaso"], "idUsuario": Auth.currentUser().rutUsuario })).toString('base64');
                    dispatch(obtenerTareasPendientes(query))
                })
                .then(() => setLoading(false));
        }
    }, [llaves])

    const formik = useFormik({
        initialValues: {
            "idCaso": "",
            "idImplicadoCaso": "",
            "idOrganizacion": "",
            "idCarpetaResExt": "",
            "codTipoGestion": "",
            "codAmbitoGestion": "",
            "glosaAmbitoGestion": "",
            "fechaAudiencia": "",
            "codHitoContacto": "",
            "fechaHitoContacto": "",
            "minutaHitoContacto": "",
            "codHitoRespuesta": "",
            "fechaHitoRespuesta": "",
            "minutaHitoRespuesta": "",
            "recepciona": "",
            "aliasApp": "",
            "idUsuario": ""
        },
        onSubmit: (formData) => {
            console.log(formData);
        }
    })


    return (
        <Fragment>
            <LoadingComponent show={loading} />
            <Form onSubmit={formik.handleSubmit}>
                <AdministracionCaso formik={formik} origen={origen}/>
            </Form>
        </Fragment>
    )
}

export default Administracion;
